<template lang="pug">
include ../pug/svg
section#grouplist
	div#ctrl
		div
			Search(v-model:search="search")
			Filter(id="statusFilter" label="Status" title="Status" :options="statusFilters" v-model:selected="statusFilter")
			button.but.circ.plus.text(type="button" @click="addGroup()")
				span Add {{terminology('user','group','singular')}}
				+svg(svg-filename="iconPlus" aria-hidden="true" alt="Add icon")
	div.wrapper
		div.c1.listbg
			ul.list
				li.group.counter(v-for="(group, index) in filteredGroups" :key="group.id" :group="group" :index="index" @mouseenter="previewIndex=index" :class="{active:previewIndex===index}")
					div.hgroup(:data-num="groupUsers(group.id).length")
						h2 {{group.name}}
						h3 Assigned {{terminology('user','user','plural')}} ({{groupUsers(group.id).length}})
					a.arrow View {{terminology('user','group','singular')}}
						+svg(svg-filename='iconArrow')
					div.butmore
						AppLink(:to="{name:'ManageGroupAssignment', params:{groupId:group.id}}") {{terminology('user','group','singular')}} Assignment
						button.but(type="button" aria-haspopup="true" aria-controls="" @mouseenter="showTint(),setMenu($event)" @mouseleave="hideTint") More
							+svg(svg-filename="iconMore" aria-hidden="true" alt="More icon")
						nav.menu(@mouseenter="showTint" @mouseleave="hideTint")
							div.bar
								+svg(svg-filename="iconMore" aria-hidden="true")
								button.but(type="button") Close
									+svg(svg-filename="iconClose")
							ul
								li
									a(@click="editGroup(group)") Edit {{terminology('user','group','singular')}}
								li
									a(v-if="group.archived" @click="archiveGroup(group.id, false)") Restore {{terminology('user','group','singular')}}
									a(v-else @click="archiveGroup(group.id, true)").bin Archive {{terminology('user','group','singular')}}
										+svg(svg-filename="iconBin" aria-hidden="true" alt="Bin icon")
		div.c2.sticky(v-if="previewGroup")
			div.preview
				div.head
					h4 {{previewGroup.name}}
					h6(v-if="previewGroup.archived") Archived
					h6 Active
				div.body
					table.column
						tr
							th Description
							td(v-if="previewGroup.description") {{previewGroup.description}}
							td(v-else) -
						tr
							th Assigned {{terminology('user','user','plural')}} ({{groupUsers(previewGroup.id).length}})
							td(v-if="groupUsers(previewGroup.id).length")
								ul.users
									li(v-for="(user, index) in groupUsers(previewGroup.id)")
										picture.user(v-if="user.profileUrl" :class="{online:user.online}")
											img(:src="user.profileUrl" width="40" height="40" :alt="user.fullName")
										span.user(v-else :class="{online:user.online}") {{user.initials}}
							td(v-else) -
	div.modal.medium.center(:class="{active:showModal}")
		div.bar
			+svg(svg-filename="iconMore" aria-hidden="true")
			span(v-if="modalGroup.id") Edit {{terminology('user','group','singular')}}
			span(v-else) Add {{terminology('user','group','singular')}}
			button.but(type="button" @click="toggleModal(false)") Close
				+svg(svg-filename="iconClose")
		div.body
			Form(ref="formGroup" :validation-schema="groupSchema" v-slot="{ errors, isSubmitting, values, meta }" @submit="saveGroup")
				//-pre meta: {{meta}}
				FieldText(name="name" label="Group Name" v-model="modalGroup.name" :required="true" :errors="errors" :validateOnInput="true")
				FieldText(name="description" label="Description" v-model="modalGroup.description" type="textarea" :required="false" :errors="errors" :validateOnInput="true")
				div.foot
					span.req Required
					button.but.pri.spinner(type="submit" :class="{spin:isSubmitting||saving}" :disabled="!meta.valid||isSubmitting||!meta.touched||saving") Save
						+svg(svg-filename="spinner" aria-hidden="true" alt="Processing")
					button.but.sec(type="button" @click="toggleModal(false)") Cancel
</template>

<script>
//import { Form, Field, ErrorMessage } from 'vee-validate';
import { Form } from 'vee-validate';
import * as Yup from 'yup';
import { mapMutations } from 'vuex';
import { mapFields, mapMultiRowFields } from 'vuex-map-fields';	
//import UserService from '../services/UserService';
import Search from '../components/Search';
import Filter from '../components/Filter';
import FieldText from '../components/FieldText';
import OrganisationService from '../services/OrganisationService';

export default {
	name: 'ManagePeople',
	components: {
		Form,
		Search,
		Filter,
		FieldText,
	},
	data() {
		const req = 'Required';
		const groupSchema = Yup.object().shape({
			name: Yup.string().matches(/^[\w\s]+$/, 'Accepts letters, numbers and spaces').required(req).nullable(),
			description: Yup.string().matches(/^[\w\s]+$/, 'Accepts letters, numbers and spaces').nullable(),
		});
		
		return {
			groupSchema,
			saving: false,
			showModal: false,
			disableForm: false,
			search: null,
			previewIndex: 0,
			modalGroup: {
				id: null,
				name: null,
				description: null,
			},
			statusFilter: 0,			
			statusFilters: [
//				{value: 0, option: 'Active'},
				{value: 1, option: 'Archived'},
			],
			idRegex: /^[0-9]+(,[0-9]+)*$/,
		}
	},
	mounted() {
		this.$store.dispatch('gui/setHeader', {
			title: this.terminology('interface', 'manage', 'singular') + ' ' + this.terminology('user','group','plural'),
			backRoute: {
				text: 'Dashboard',
				name: 'Dashboard',
			},			
		});
		
		if (this.$route.query.ids) {
			// validate passed ids
			if (this.$route.query.ids.match(this.idRegex)) {
				this.search = this.$route.query.ids;
			}
		}
		
		this.refreshGroups();		
	},
	computed: {
		...mapFields('gui', { // get/set vuex store (aliased)
			org: 'organisation',
		}),
		...mapMultiRowFields('gui', {
			groups: 'organisation.organisationGroups',
		}),
		filteredGroups() {
			// status filter
			let f1 = (this.statusFilter) ? this.groups.filter(g => g.archived === this.statusFilter.value) : this.groups.filter(g => g.archived === 0);
			
			// serch term filter
			if (this.search) {				
				if (this.search.match(this.idRegex) !== null) {
					// id search
					const ids = this.search.split(',').map(id => { 
						return parseInt(id);
					});
					
					return f1.filter(g => ids.includes(g.id));
					
				} else {
					// name search
					return f1.filter(u => u.fullName.toLowerCase().includes(this.search.toLowerCase()));
				}
				
			} else {
				return f1;
			}		
		},
		users() {
			// copy store to local (allows list sorting)
			let users = [...this.$store.state.users.users].sort((a, b) => a.fullName.localeCompare(b.fullName));
			
			return users.filter(u => u.userOrganisations[0].status !== 'archived');
		},
		previewGroup() {
			return this.filteredGroups[this.previewIndex];
		}
	},
	methods: {
		...mapMutations('gui', ['addOrganisationGroup']),
		terminology(groupKey, termKey, varKey) {
			return this.$store.getters['gui/customTerm'](groupKey, termKey, varKey);
		},
		capitalise(word) {
			return word[0].toUpperCase() + word.substr(1).toLowerCase();
		},
		capitaliseAll(sentence) {
			const words = sentence.split(' ');
			
			for (let i = 0; i < words.length; i++) {
				words[i] = this.capitalise(words[i]);
			}
			
			return words.join(' ');	
		},
		toggleModal(mode) {
			this.showModal = mode;
			
			if (this.showModal) {
				this.showTint();
				
			} else {
				this.hideTint();
			}
		},
		showTint() {
			this.$store.dispatch('gui/setTintState', true);
		},
		hideTint() {
			if (!this.showModal) {
				this.$store.dispatch('gui/setTintState', false);
			}
		},
		setMenu(event) {
			if (event.target.nodeName === 'BUTTON' && event.relatedTarget.nodeName !== 'NAV') {
				const menu = event.target.nextSibling;
				menu.classList.remove('reverse');				
				const rect = menu.getBoundingClientRect();
				
				if (rect.bottom > window.innerHeight) {
					menu.classList.add('reverse');
				}
			}
		},
		groupUsers(groupId) {
			return this.users.filter(u => u.userOrganisations[0].userOrganisationGroups.find(ug => ug.organisationGroupId === groupId));
		},
		addGroup() {
			const form = this.$refs.formGroup;
			
			for(const field in form.getValues()) {
				form.resetField(field, {
					value: null,
				});
			}
			
			this.modalGroup.id = null;
			
			this.toggleModal(true);
		},
		editGroup(group) {
			const form = this.$refs.formGroup;
			
			for(const field in form.getValues()) {
				form.resetField(field, {
					value: group[field],
				});
			}
			
			this.modalGroup.id = group.id;
			
			this.toggleModal(true);
		},
		async saveGroup(values, actions) {
			try {
				this.saving = true;
				
				const archiving = (values.id) ? true : false;
				const delay = this.$store.getters['gui/delay'];
				const id = values.id || this.modalGroup.id; // id passed via archiveGroup()
				
				let response;
				let group = this.groups.find(g => g.id === id) || {};
				let data = {
					name: this.capitaliseAll(values.name),
					description: values.description,
					archived: (values.id) ? values.archived : group.archived,
				};
				
				if (group.id) {
					data.id = group.id,
					// update db
					response = await OrganisationService.updateGroup(data);
					
					if (!archiving) {
						await delay;
					}
					
					// update store
					group.name = response.data.group.name;
					group.description = response.data.group.description;
					group.archived = response.data.group.archived;
					
				} else {
					// add new group
					response = await OrganisationService.createGroup(data);
					
					await delay;
					
					// add to store
					this.addOrganisationGroup(response.data.group);
				}
				
				if (response.status === 200) {
					this.saving = false;
					this.toggleModal(false);
				}
				
			} catch(err) {
				if (err.response.status === 409) {
					actions.setFieldError('name', err.response.data.message);
					this.saving = false;
				}
				console.log('err:', err.response);
			}
		},
		archiveGroup(groupId, bool) {
			let group = this.filteredGroups.find(g => g.id === groupId);
			
			// update store
			group.archived = bool ? 1 : 0;
			
			this.saveGroup(group);
		},
		async refreshGroups() {
			// load groups from db
			await this.$store.dispatch('gui/initOrganisation');
			// load people from db
			await this.$store.dispatch('users/dbUsers');
		},
	},
}
</script>

<style lang="scss">
#grouplist {
	.wrapper {
		display: flex;
		width: 100%;
		flex-grow: 1;
	}
	span.user {
		font-size: 12px;
		font-weight: 500;
	}
	ul.users {
		display: flex;
		flex-wrap: wrap;
		padding-left: 10px;
		li {
			margin: 5px 0 5px -10px;
		}
	}
}
/*@media (max-width: 960px) {
	#th.menu #peoplelist {
		.preview {
			display: none;
		}
	}
}
@media (max-width: 1160px) {
	#th:not(.menu) #peoplelist {
		.c2 {
			display: none;
		}
	}
}*/
</style>
